import React from 'react';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-purple-100">
    <div className="text-center">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600 mx-auto"></div>
      <p className="mt-4 text-purple-700 font-medium">Cargando CUALAPP...</p>
    </div>
  </div>
);

export default LoadingSpinner;
